import NoticeVisitDatailsTabs from "./notice-visit-tabs";

export default NoticeVisitDatailsTabs;